<template>
  <ZMainPage type="card">
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
      <el-button class="text-primary ml-1 c-p" @click="handleView">查看原始数据</el-button>
      <el-button v-if="coach_evaluation?.id" class="text-primary ml-1 c-p" @click="handleDetail">查看学生评价表</el-button>
    </template>
    <div class="z-box-bg brl mb-2">
      <LineWrapper class="list" list>
        <LineItem v-for="(item, index) in list" :key="index" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
    </div>
    <template v-if="report">
      <div class="flex gap-2 mb-2">
        <div class="z-box-bg brl flex-3">
          <div class="z-box-title n">
            <span class="z-box-title-text">{{ info.content_tag === 'AI生成' ? '辅导谈话分析报告' : '辅导核心主旨' }}</span>
          </div>
          <div class="tag-box mb-2">
            <div class="tag-item"><i class="el-icon-info" style="margin-right: 6rem;"></i>是否重点检查：{{ report.grade }}</div>
            <div class="tag-item"><i class="el-icon-success" style="margin-right: 6rem;"></i>是否符合要求：{{ report.qualified }}</div>
            <div class="tag-item"><i class="el-icon-s-opportunity" style="margin-right: 6rem;"></i>是否需要重点关注：{{ report.focus_on }}</div>
          </div>
          <div class="info-box" style="min-height: 154rem;">
            {{ report.theme }}
          </div>
        </div>
        <template v-if="info.content_tag === 'AI生成'">
            <div class="z-box-bg brl flex-1">
            <div class="z-box-title n">
              <span class="z-box-title-text">辅导类型占比</span>
            </div>
            <div>
              <div v-if="option1" class="chart-box" ref="chart1" />
              <div v-else class="chart-box flex-center"><zu-empty /></div>
            </div>
          </div>
          <div class="z-box-bg brl flex-1">
            <div class="z-box-title n">
              <span class="z-box-title-text">师生说话占比</span>
            </div>
            <div>
              <div v-if="option2" class="chart-box" ref="chart2" />
              <div v-else class="chart-box flex-center"><zu-empty /></div>
            </div>
          </div>
        </template>
      </div>
      
      <div class="flex gap-2 mb-2">
        <div class="z-box-bg brl flex-1">
          <div class="z-box-title n flex align-center">
            <img src="/img/moral/teacher-work/md-01.png" style="width: 24rem;height: 24rem;margin-right: 10rem;">
            <span class="z-box-title-text">目标管理分析</span>
          </div>
          <div class="fen-box">
            <div class="fen-tit">核心诉求</div>
            <div class="fen-txt">{{ report?.student_goal?.core_summary }}</div>
            <div class="fen-tit">分析结论</div>
            <div class="fen-txt">{{ report?.student_goal?.analysis_conclusion }}</div>
          </div>
          <template v-if="info.content_tag === 'AI生成'">
            <div class="fen-title pt-2">相关对话证据</div>
            <div class="fen-list">
              <div v-for="(i, idx) in report?.student_goal?.related_content" :key="idx" class="fen-item">
                <div class="type">{{ i.speaker }}</div>
                <div class="info">
                  <div class="no">{{ i.sentence_num }}</div>
                  <div class="txt">{{ i.content }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="z-box-bg brl flex-1">
          <div class="z-box-title n flex align-center">
            <img src="/img/moral/teacher-work/md-02.png" style="width: 24rem;height: 24rem;margin-right: 10rem;">
            <span class="z-box-title-text">情绪管理分析</span>
          </div>
          <div class="fen-box">
            <div class="fen-tit">核心诉求</div>
            <div class="fen-txt">{{ report?.student_emotions?.core_summary }}</div>
            <div class="fen-tit">分析结论</div>
            <div class="fen-txt">{{ report?.student_emotions?.analysis_conclusion }}</div>
          </div>
          <template v-if="info.content_tag === 'AI生成'">
            <div class="fen-title pt-2">相关对话证据</div>
            <div class="fen-list">
              <div v-for="(i, idx) in report?.student_emotions?.related_content" :key="idx" class="fen-item">
                <div class="type">{{ i.speaker }}</div>
                <div class="info">
                  <div class="no">{{ i.sentence_num }}</div>
                  <div class="txt">{{ i.content }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="z-box-bg brl mb-2">
        <div class="z-box-title n">
          <span class="z-box-title-text">建议下次谈话内容</span>
        </div>
        <div class="info-box">
          {{report.next_time}}
        </div>
      </div>
    </template>
    <div v-else class="z-box-bg brl mb-2">
      <template v-if="info.coach_content">
          <div class="z-box-title n">
          <span class="z-box-title-text">{{ info.content_tag === 'AI生成' ? '辅导谈话分析报告' : '辅导核心主旨' }}</span>
        </div>
        <div class="info-box">
          {{ info.coach_content }}
        </div>
      </template>
      <zu-empty v-else />
    </div>
    <div v-if="AI_analysis" class="z-box-bg brl mb-2">
      <div class="z-box-title n">
        <span class="z-box-title-text">验收系统评分</span>
      </div>
      <div class="box2">
        <div class="score">{{ AI_analysis.score }}</div>
        <div class="info-box">{{ AI_analysis.text }}</div>
      </div>
    </div>
    <div v-if="coach_evaluation" class="z-box-bg brl mb-2">
      <div class="z-box-title n">
        <span class="z-box-title-text">学生评价得分</span>
      </div>
      <div class="box2">
        <div class="score">{{ coach_evaluation.score }}</div>
        <div class="info-box">{{ coach_evaluation.text }}</div>
      </div>
    </div>
		<Dialog
      title="查看原始数据"
      :visible.sync="visible"
      :showCancelButton="false"
      buttonAlign="center"
      size="large"
      submitText="关闭"
    >
      <div>{{ info.content_from || info.coach_content }}</div>
		</Dialog>
  </ZMainPage>
</template>

<script>
import LineItem from "@/components/common/LineItem";
import LineWrapper from "@/components/common/LineWrapper";
import Dialog from '@/components/common/Dialog.vue'
import ZuEmpty from '@/components/common/ZuEmpty'
import http from '@/api'
import * as eCharts from 'echarts'
export default {
	_config:{'route':{'path':'detail','meta':{'title':'详情'}}},
  components: { LineItem, LineWrapper, Dialog, ZuEmpty },
  data() {
    return {
      visible: false,
      list: [],
      report: null,
      info: {
        content_tag: '',
        coach_content: '',
        content_from: ''
      },
      coach_evaluation: null,
      AI_analysis: null,
      option1: null,
      option2: null,
      chart1: null,
      chart2: null,
    };
  },
  
  beforeDestroy() {
    this.disposeEChart()
  },
  created() {
    this.getData()
  },
  methods: {
    resize() {
      if (this.chart1) this.chart1.resize()
      if (this.chart2) this.chart2.resize()
    },
    initEChart() {
      this.$refs.chart1 && (this.chart1 = eCharts.init(this.$refs.chart1))
      this.$refs.chart2 && (this.chart2 = eCharts.init(this.$refs.chart2))
      window.addEventListener('resize', this.resize)
    },
    disposeEChart() {
      window.removeEventListener('resize', this.resize)
      if (this.chart1) {
        eCharts.dispose(this.$refs.chart1)
        this.chart1 = null
      }
      if (this.chart2) {
        eCharts.dispose(this.$refs.chart2)
        this.chart2 = null
      }
    },
    getData() {
      http({ url: '/teacher/moral-educationController/record-details', pre: 'api2'}, {
        id: this.$route.query.id,
        type: this.$route.query.type
      }).then(res => {
        const { coach_content, content_tag, report, content_from } = res
        this.info = { coach_content, content_tag, content_from }
        this.report = report
        if (res.coach_evaluation.evaluation || res.coach_evaluation.total_score) {
          this.coach_evaluation = { score: res.coach_evaluation.total_score, text: res.coach_evaluation.evaluation, id: res.coach_evaluation.id }
        }
        if (res.AI_analysis.score || res.AI_analysis.reason) {
          this.AI_analysis = { score: res.AI_analysis.score, text: res.AI_analysis.reason }
        }
        this.list = [
          { label: '学生姓名', value: res.student_name },
          { label: '学号', value: res.student_no },
          { label: '辅导教师', value: res.org_teacher_name || '-' },
          { label: '辅导完成时间', value: res.coach_time || '-' },
          { label: '录入方式', value: res.content_tag },
          { label: '校区', value: res.school_name },
          { label: '年级', value: res.grade_name },
          { label: '行政班', value: res.class_name },
          { label: '班主任', value: res.class_teacher },
          { label: '考核周期', value: res.day_describe },
        ]
        
        if (!report) return
        const arr1 = report.type || []
        const arr2 = report.role || []
        const data1 = arr1.map(i => ({ name: i.name, value: i.proportion  }))
        const data2 = arr2.map(i => ({ name: i.name, value: i.proportion  }))
        const option1 = {
          tooltip: { trigger: 'item' },
          legend: { bottom: '5%', left: 'center' },
          series: [
            {
              name: '辅导类型占比',
              type: 'pie',
              radius: ['40%', '65%'],
              center: ['50%', '60%'],
              startAngle: 180,
              endAngle: 360,
              color: ['#7953FF', '#F65E47'],
              data: data1
            }
          ]
        }
        const option2 = {
          tooltip: { trigger: 'item' },
          legend: { bottom: '5%', left: 'center' },
          series: [
            {
              name: '师生说话占比',
              type: 'pie',
              radius: ['40%', '65%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 4,
                borderColor: '#fff',
                borderWidth: 2,
              },
              color: ['#90BE6D', '#477BF6'],
              label: { show: false, position: 'center' },
              emphasis: { label: { show: true, fontSize: 16, fontWeight: 'bold' } },
              labelLine: { show: false },
              data: data2
            }
          ]
        }
        data1.length && (this.option1 = option1)
        data2.length && (this.option2 = option2)
        this.$nextTick(() => {
          this.initEChart()
          data1.length && this.chart1?.setOption(option1)
          data2.length && this.chart2?.setOption(option2)
        })
      })
    },
    handleView() {
      this.visible = true
    },
    handleDetail() {
      this.$router.push({ path: '/moral/one-on-one-tutoring/questionnaire/detail', query: { id: this.coach_evaluation.id }})
    }
  },
}
</script>

<style lang="scss" scoped>
.tag-box {
  display: flex;
  gap: 20rem;
}
.tag-item {
  padding: 0 10rem;
  line-height: 26rem;
  display: flex;
  align-items: center;
  border-radius: 26rem;
  &:nth-child(1) { 
    color: #5D94C8;
    background-color: #DCEDFF;
  }
  &:nth-child(2) { 
    color: #5DA738;
    background-color: #D9FAD9;
  }
  &:nth-child(3) { 
    color: #BC793A;
    background-color: #FFF1DC;
  }
}
.info-box {
  padding: 20rem;
  font-size: 14rem;
  line-height: 20rem;
  background-color: #F9FAFD;
  border-radius: 6rem;
}

.fen {
  &-box { 
    padding: 16rem;
    background-color: #F9FAFE;
    border-radius: 8rem;
  }
  &-tit {
    padding: 0 10rem;
    margin-bottom: 12rem;
    font-size: 14rem;
    color: #70768F;
    line-height: 24rem;
    background-color: #EAEEFF;
    border-radius: 4rem;
    display: inline-block;
  }
  &-txt {
    font-size: 13rem;
    color: #3D3D3D;
    &:not(:last-child) { 
      margin-bottom: 20rem;
    }
  }
  &-title {
    margin-bottom: 10rem;
    font-size: 15rem;
    color: #3D3D3D;
  }
  &-item {
    padding-left: 26rem;
    font-size: 11rem;
    &:not(:last-child) { 
      margin-bottom: 16rem;
    }
    .info {
      position: relative; 
    }
    .no {
      position: absolute;
      left: -26rem;
      top: 50%;
      width: 16rem;
      height: 16rem;
      color: #3F95FF;
      line-height: 16rem;
      text-align: center;
      background-color: #C0DAFA;
      transform: translateY(-50%);
      border-radius: 50%;
    }
    .type {
      margin-bottom: 10rem;
      font-size: 12rem;
    }
    .txt {
      padding: 10rem;
      line-height: 15rem;
      background-color: #F0F6FF;
      border-radius: 8rem;
    }
  }
}
.chart-box {
  height: 200rem;
}
.box2 {
  display: flex;
  align-items: center;
  .score {
    width: 180rem;
    text-align: center;
    font-size: 40rem;
    color: #3D3D3D;
    flex-shrink: 0;
  }
  .info-box {
    min-height: 120rem;
    flex: 1;
  }
}
</style>
